import { Close } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import toast from "react-hot-toast";

import { theme } from "../../../../assets";
import {
    DataProjectFile,
    useReadProjectFiles,
} from "../../../../hooks/react-query/project/use-read-project-files";
import { TProject } from "../../../../models";
import { deleteProjectFile } from "../../../../services/projects";
import { TUseFetch } from "../../../../types/TUseFetch";
import FilesForm from "./files-form";

type TFilesTabProps = {
    project: TProject;
    getProject: TUseFetch;
};

function FilesTab({ getProject, project }: TFilesTabProps) {
    const { data, refetch } = useReadProjectFiles({ projectId: project.id_e });

    const files: DataProjectFile[] = data?.data ?? [];
    const handleRemove = async (attachmentId: string) => {
        await deleteProjectFile({ projectId: project.id_e, attachmentId }).then(
            async () => {
                toast.success("Anexo excluido com sucesso!");
                await refetch();
            }
        );
    };

    return (
        <Stack>
            <Stack
                sx={{
                    justifyContent: "center",
                    gap: "0.5rem",
                    p: "1.5rem",
                    borderBottom: "1px solid rgba(224, 224, 224, 1)",
                    borderTop: "1px solid rgba(224, 224, 224, 1)",
                }}
            >
                <Typography variant="h5">Anexos</Typography>
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: "rgba(62, 55, 78, 0.60)",
                        fontFamily: "Noto Sans",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "18px",
                        letterSpacing: "0.07px",
                    }}
                >
                    Faça upload de arquivos importantes para documentação.
                </Typography>
            </Stack>
            <Stack
                sx={{
                    p: "1.5rem",
                    gap: "1.5rem",
                }}
            >
                <Typography variant="h5">Arquivos de Orçamento</Typography>
                <Typography
                    variant="subtitle2"
                    sx={{
                        color: "rgba(62, 55, 78, 0.60)",
                        fontFamily: "Noto Sans",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "18px",
                        letterSpacing: "0.07px",
                    }}
                >
                    faça upload de arquivos importantes para documentação{" "}
                </Typography>
                <FilesForm projectId={project.id_e} refetch={refetch} />
                <Stack
                    sx={{
                        gap: "1.5rem",
                        maxHeight: "28.5rem",
                        pt: "1rem",
                        overflowY: "auto",
                    }}
                >
                    {/* Files list */}
                    <Stack>
                        {files?.map((file) => (
                            <Box
                                key={file.id_e}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "auto",
                                    gap: "0.5rem",
                                    color: theme.primary.main,
                                }}
                            >
                                <Typography
                                    component="a"
                                    href={file.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        color: theme.primary.main,
                                        textDecoration: "underline",
                                    }}
                                >
                                    {file.name}
                                </Typography>
                                <IconButton
                                    onClick={() => handleRemove(file.id_e)}
                                    size="small"
                                >
                                    <Close
                                        fontSize="small"
                                        sx={{
                                            color: theme.primary.main,
                                        }}
                                    />
                                </IconButton>
                            </Box>
                        ))}
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
}

export default FilesTab;
